// src/app/modules/AccessControl/pages/access-logs-table/column-formatters/ActionsColumnFormatter.jsx
import React from "react";
import { LogOut } from 'lucide-react';

export function ActionsColumnFormatter(cellContent, row, rowIndex, { onCheckout }) {
  const canCheckout = row.status === 'checked_in';

  if (!canCheckout) {
    return <span className="sety-tbl-sub">—</span>;
  }

  return (
    <button
      title="Check out visitor"
      className="sety-btn sety-btn-ghost"
      style={{ padding: '6px 10px' }}
      onClick={() => onCheckout(row.log_id, row)} // ✅ Pass full row object
    >
      <LogOut size={15} />
    </button>
  );
}
